import { Component, CUSTOM_ELEMENTS_SCHEMA, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ShareModule } from '../share.module';
import { DataService } from '../services/data.service';
import { FilterCriteriaService } from '../services/filter-criteria.service';
import { GetFilterQueryResponse, AllQueryFilterResponse } from '../../models/filter-payload.model';
import { QUERY_TABLE_HEADERS_FILTERS,QUERY_TABLE_HEADERS_TEMPLATE,QueryType, USER_TYPE} from '../constants/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Notification,NotificationComponent } from '../notification/notification.component';
import { SaveColumnsService, SaveColumnPayload } from '../services/save.columns.service';
import { UserColumn } from '../../models/user-info.model';
import { ConfigureColumnsComponent } from './configure-columns/configure-columns.component';
import { LandingPageApiService } from '../services/landing-page-api.service';
import { sortQueriesByFavoriteAndName as sortQueriesByFavoriteAndNameUtil } from '../shared/utils/query-sorting.util';
export interface ProjectInfo {
  projectID: string;
  updateID: string;
  updateType: string;
  basicInfoReady: boolean;
  documentsReady: boolean;
  filterReady: boolean;
  rollOutReady: boolean;
  monitoringReady: boolean;
  createdOn: string; 
  createdBy: string;
  lastChangedOn: string;
  lastChangeBy: string;
  status: string;
  bls: string[];
}

@Component({
  selector: 'app-all-query-table',
  imports: [ShareModule,NotificationComponent, ConfigureColumnsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  templateUrl: './all-query-table.component.html',
  styleUrl: './all-query-table.component.scss'
})
export class AllQueryTableComponent implements OnInit {
  
  @ViewChild('dt1') dt1!: Table;
  @ViewChild('shPagination') shPagination!: ElementRef;
  notification!: Notification;
  showMoreVisibilityPopup: boolean = false;
  showColumnVisibilityPopup: boolean = false;
  showRenameModal: boolean = false;
  isLoading = false;
  isSaving = false;
  queries: GetFilterQueryResponse[] = [];
  tableHeaders: {
    colName: string;
    label: string;
    displayName: string;
    columns: number;
    visible: boolean;
    isSortable?: boolean;
    filterType?: string;
}[] = [];
  sortField: string = '';
  sortOrder: 1 | -1 = 1;
  columnFilters: { [colName: string]: string } = {};
  processedQueries: GetFilterQueryResponse[] = [];
  selectedQuery: GetFilterQueryResponse | null = null;
  newQueryName: string = '';
  renameNameError: string = '';
  commentText: string = '';
  commentError = '';
  showDeleteConfirmModal: boolean = false;
  selectedQueries: GetFilterQueryResponse[] = [];
  editCommentModal: boolean = false;
  expandtableModal: boolean = false;
  activeFilterTab = 'filter';
  allQueries: AllQueryFilterResponse = { filter: [], template: [] };
  QueryType = QueryType;
  defaultQueryGuid: string = '';
  showSetDefaultModal: boolean = false;
  pendingDefaultQuery: any = null;
  isManageTemplatePage: boolean = false;
  allQueriesFiltered: GetFilterQueryResponse[] = [];
  searchValue: string = '';
  isOthersSearchLoading: boolean = false;
  isShowingOthersResults: boolean = false;
  pageIndex: number = 1;
  pageSize: number = 10;
  pageSizeOptions: (number | string)[] = [10, 25, 50, 'All'];
  paginatedQueries: GetFilterQueryResponse[] = [];
  showAll: boolean = false;

  constructor(
    private filterCriteriaService: FilterCriteriaService,
    public dataService: DataService,
    private route: Router,
    private saveColumnsService: SaveColumnsService,
    readonly activatedRoute: ActivatedRoute,
    readonly landingPageService: LandingPageApiService
  ) {}

  ngOnInit(): void {
    this.isManageTemplatePage = this.activatedRoute.snapshot.data['queryType'] === 'template';
    this.tableHeaders = this.isManageTemplatePage ? QUERY_TABLE_HEADERS_TEMPLATE : QUERY_TABLE_HEADERS_FILTERS;
    this.loadSavedColumnOrder();
    this.loadAllYourQueries();
  }

  loadAllYourQueries() {
    this.isLoading = true;
    this.filterCriteriaService.getAllFilterQueries().subscribe({
      next: (filterQueries) => {
        this.isLoading = false;
        this.allQueries = filterQueries;
        this.setActiveFilterTab(this.isManageTemplatePage ? 'template' : 'filter');
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error loading filter queries:', err);
      }
    });
  }
  toggleMoreVisibilityPopup(query?: GetFilterQueryResponse): void {
    this.selectedQuery = query || null;
    this.showMoreVisibilityPopup = !this.showMoreVisibilityPopup;
  }

  openRenameModal(): void {
    if (this.selectedQuery) {
      this.newQueryName = this.selectedQuery.name;
      this.renameNameError = '';
      this.showRenameModal = true;
      this.showMoreVisibilityPopup = false;
    }
  }

  onCommentTextChange(value: string): void {
    if (value && value.length > 250) {
      this.commentError = `Text exceeds 250 characters (current: ${value.length}). Please reduce the content before saving.`;
    } else {
      this.commentError = '';
    }
  }

  openEditCommentModal(): void {
    if(this.selectedQuery) {
      this.commentText = this.selectedQuery.comments || '';
      this.onCommentTextChange(this.commentText);
      this.editCommentModal = true;
      this.showMoreVisibilityPopup = false;
    }
  }

  closeRenameModal(): void {
    this.showRenameModal = false;
    this.newQueryName = '';
    this.renameNameError = '';
    this.isSaving = false;
  }

  closeEditCommentModal(): void {
    this.editCommentModal = false;
    this.commentText = '';
    this.commentError = '';
    this.isSaving = false;
  }

  saveNewName(): void {
    if (this.selectedQuery && this.newQueryName.trim() && !this.isSaving) {
      const trimmedName = this.newQueryName.trim();

      if (this.isDuplicateQueryName(trimmedName)) {
        this.renameNameError = `A ${this.isManageTemplatePage ? 'template' : 'query'} with this name already exists.`;
        return;
      }

      this.renameNameError = '';
      this.isSaving = true;

      const renamePayload = {
        guid: this.selectedQuery.guid,
        name: trimmedName
      };

      this.filterCriteriaService.renameFilter(renamePayload).subscribe({
        next: (response) => {
          
          if (this.selectedQuery) {
            this.selectedQuery.name = trimmedName;
          }
          this.isSaving = false;
          this.showRenameModal = false;

        },
        error: (error) => {
          console.error('Error renaming query:', error);
          this.isSaving = false;
        }
      });
    }
  }

  isDuplicateQueryName(name: string): boolean {
    if (!this.selectedQuery || !name) {
      return false;
    }
    const normalized = name.trim().toLowerCase();
    const tab: 'filter' | 'template' = this.activeFilterTab === 'template' ? 'template' : 'filter';
    const list = this.allQueries?.[tab] ?? [];
    return list.some(q =>
      q.guid !== this.selectedQuery!.guid &&
      (q.name ?? '').trim().toLowerCase() === normalized
    );
  }

  canManageQuery(query: GetFilterQueryResponse): boolean {
    if (!query) {
      return false;
    }
    // Admins can manage any query in the user's own list
    return this.isUserAdmin;
  }

  openDeleteConfirmModal(): void {
    this.showDeleteConfirmModal = true;
    this.showMoreVisibilityPopup = false;
  }

  closeDeleteConfirmModal(): void {
    this.showDeleteConfirmModal = false;
  }

  onRowCheckboxChange(query: GetFilterQueryResponse): void {
    const index = this.selectedQueries.findIndex(q => q.guid === query.guid);
    
    if (index > -1) {
      this.selectedQueries.splice(index, 1);
    } else {
      this.selectedQueries.push(query);
    }
  }

  isQuerySelected(query: GetFilterQueryResponse): boolean {
    return this.selectedQueries.some(q => q.guid === query.guid);
  }

  deleteSelectedQueries(): void {
    if (this.selectedQueries.length === 0) return;
    this.showDeleteConfirmModal = true;
  }

  deleteQuery(): void {
    if (this.selectedQuery) {
      this.isSaving = true;
      this.filterCriteriaService.deleteFilter(this.selectedQuery.guid).subscribe({
        next: (response) => {
          const deletedGuid = this.selectedQuery?.guid;

          this.queries = this.queries.filter(q => q.guid !== deletedGuid);
          this.allQueriesFiltered = this.allQueriesFiltered.filter(q => q.guid !== deletedGuid);
          this.allQueries.filter = this.allQueries.filter.filter(q => q.guid !== deletedGuid);
          this.allQueries.template = this.allQueries.template.filter(q => q.guid !== deletedGuid);

          this.updatePaginatedQueries(); 

          this.showDeleteConfirmModal = false;
          this.selectedQuery = null;
          this.isSaving = false;

          this.notification = {
            label: 'Success',
            description: 'Query deleted successfully',
            type: 'success',
          };
        },
        error: (error) => {
          console.error('Error deleting query:', error);
          this.isSaving = false;

          this.notification = {
            label: 'Error',
            description: 'Failed to delete query. Please try again.',
            type: 'error',
          };
        }
      });
    } else if (this.selectedQueries.length > 0) {
      const guidsToDelete = this.selectedQueries.map(q => q.guid);
      this.isSaving = true;

      this.filterCriteriaService.deleteFilters(guidsToDelete).subscribe({
        next: (response: any) => {
          if (response.deleted && response.deleted.length > 0) {
            this.queries = this.queries.filter(q => !response.deleted.includes(q.guid));
            this.allQueriesFiltered = this.allQueriesFiltered.filter(q => !response.deleted.includes(q.guid));
            this.allQueries.filter = this.allQueries.filter.filter(q => !response.deleted.includes(q.guid));
            this.allQueries.template = this.allQueries.template.filter(q => !response.deleted.includes(q.guid));
          }

          this.updatePaginatedQueries(); 

          this.selectedQueries = [];
          this.showDeleteConfirmModal = false;
          this.isSaving = false;

          if (response.failed && response.failed.length > 0) {
            this.notification = {
              label: 'Error',
              description: `Successfully deleted ${response.deleted.length} query(ies). Failed to delete ${response.failed.length} query(ies).`,
              type: 'error',
            };
          } else {
            this.notification = {
              label: 'Success',
              description: `Successfully deleted ${response.deleted.length} queries`,
              type: 'success',
            };
          }
        },
        error: (error) => {
          console.error('Error deleting queries:', error);
          this.isSaving = false;

          this.notification = {
            label: 'Error',
            description: 'Failed to delete queries. Please try again.',
            type: 'error',
          };
        }
      });
    }
  }

  routeToSelectedQuery(query: GetFilterQueryResponse) {
     this.dataService.selectedGUID = query.guid;
     this.dataService.selectedFilterName = query.name;
     this.route.navigate(['/filter-criteria', query.guid]);
  }
onSearchInput(event: any): void {
    const rawValue = (event.target as HTMLInputElement).value;
    this.searchValue = rawValue; // keep original casing for display in banner & button

    // Re-enable Search All button and restore own list when user modifies input after search
    if (this.isShowingOthersResults) {
      this.isShowingOthersResults = false;
      this.queries = [...this.allQueriesFiltered];
      this.pageIndex = 1;
      this.updatePaginatedQueries();
    }

    this.applySearch(rawValue.toLowerCase().trim());
  }

  onSearchClear(event: any) {
    this.searchValue = '';
    this.isShowingOthersResults = false;
    this.queries = [...this.allQueriesFiltered];
    this.pageIndex = 1;                 
    this.updatePaginatedQueries();   
    this.loadAllYourQueries();    
  }

  private applySearch(value: string): void {
    if (!value) {
      this.queries = [...this.allQueriesFiltered];
      this.updatePaginatedQueries();     
      return;
    }
    this.queries = this.allQueriesFiltered.filter(q =>
      q.name?.toLowerCase().includes(value) ||
      q.projectId?.toLowerCase().includes(value) ||
      q.id?.toString().toLowerCase().includes(value)
    );
    this.pageIndex = 1;                  
    this.updatePaginatedQueries();       
  }

  onRenameRestrict(event: any): void {
    const input = event.target.value;
    const validPattern = /^[a-zA-Z0-9\s\-_.,()\&]*$/;

    if (!validPattern.test(input)) {
      this.newQueryName = input.replace(/[^a-zA-Z0-9\s\-_.,()\&]/g, '');
      event.target.value = this.newQueryName;
    }

    const trimmed = (this.newQueryName ?? '').trim();
    if (trimmed && this.isDuplicateQueryName(trimmed)) {
      this.renameNameError = `A ${this.isManageTemplatePage ? 'template' : 'query'} with this name already exists.`;
    } else {
      this.renameNameError = '';
    }
  }

  saveUpdatedComment(): void {
    if (this.selectedQuery && !this.isSaving) {
      const trimmedComment = (this.commentText || '').trim();

      if (trimmedComment.length > 250) {
        this.commentError = `Text exceeds 250 characters (current: ${trimmedComment.length}). Please reduce the content before saving.`;
        return;
      }

      this.isSaving = true;

      this.filterCriteriaService.updateFilterComments(
        this.selectedQuery.guid,
        trimmedComment
      ).subscribe({
        next: (response) => {
          if (this.selectedQuery) {
            this.selectedQuery.comments = trimmedComment;
          }
          this.isSaving = false;
          this.editCommentModal = false;
          this.commentText = '';
          this.commentError = '';
        },
        error: (error) => {
          console.error('Error updating comments:', error);
          this.isSaving = false;
        }
      });
    }
  }

  setActiveFilterTab(tabName: 'filter' | 'template') {
    this.activeFilterTab = tabName;
    const filterOrTemplateList = (this.allQueries[tabName] ?? []);
    this.queries = this.sortQueriesByFavoriteAndName(
      filterOrTemplateList.map(query => ({
        ...query,
        createdOnFormatted: query.createdOn.split('T')[0],
        updatedOnFormatted: query.updatedon?.split('T')[0],
      }))
    );

    this.allQueriesFiltered = [...this.queries]; 
    this.searchValue = '';
    this.sortField = '';
    this.sortOrder = 1;
    this.columnFilters = {};
    this.pageIndex = 1;                  
    this.updatePaginatedQueries();       

    if (tabName === 'template') {
      const defaultQuery = this.queries.find(q => q.isDefault === true);
      this.defaultQueryGuid = defaultQuery ? defaultQuery.guid : '';
    }
  }

   getTypeLabel(type: string): string {
    switch (type) {
      case QueryType.Public_Template: return 'Public';
      case QueryType.Template:        return 'Personal';
      case QueryType.Standard:        return 'Standard';
      default:                        return type;
    }
  }

  getTableScrollHeight(): string {
    return this.expandtableModal ? 'calc(90vh - 150px)' : 'calc(100vh - 420px)';
  }

  openExpandModal() {
    this.expandtableModal = !this.expandtableModal;
  }

  closeExpandModal() {
    this.expandtableModal = false;
  }

  toggleColumnVisibilityPopup(): void {
    this.showColumnVisibilityPopup = !this.showColumnVisibilityPopup;
  }

  onColumnVisibilityChange(columnToToggle: any, event: Event): void {
    const columnIndex = this.tableHeaders.findIndex(col => col.colName === columnToToggle.colName);
    if (columnIndex > -1) {
      const detail = (event as any).detail;
      let isChecked: boolean;

      if (typeof detail === 'boolean') {
        isChecked = detail;
      } else if (typeof detail?.checked === 'boolean') {
        isChecked = detail.checked;
      } else {
        const target = event.target as (EventTarget & { active?: boolean; checked?: boolean }) | null;
        if (typeof target?.active === 'boolean') {
          isChecked = target.active;
        } else if (typeof target?.checked === 'boolean') {
          isChecked = target.checked;
        } else {
          isChecked = !this.tableHeaders[columnIndex].visible;
        }
      }
      this.tableHeaders[columnIndex].visible = isChecked;
      this.saveColumnOrderToDatabase();
    }
  }

  get visibleTableHeaders() {
    return this.tableHeaders.filter(header => header.visible);
  }

  get hasFilterableColumns(): boolean {
    return this.visibleTableHeaders.some(header => header.filterType === 'select');
  }

  onColumnReorder(event: any): void {
    const visibleColumns = this.visibleTableHeaders;
    
    const reorderedVisibleColumns = [...visibleColumns];
    const movedColumn = reorderedVisibleColumns.splice(event.dragIndex, 1)[0];
    reorderedVisibleColumns.splice(event.dropIndex, 0, movedColumn);
    
    const hiddenColumns = this.tableHeaders.filter(col => !col.visible);
    
    this.tableHeaders = [...reorderedVisibleColumns, ...hiddenColumns];
    
    this.saveColumnOrderToDatabase();
  }

  private saveColumnOrderToDatabase(): void {
    const userColumns: UserColumn[] = this.tableHeaders.map((col, index) => ({
      order: index + 1,
      name: col.colName,
      visible: col.visible === true
    }));

    const payload: SaveColumnPayload = {
      userColumns: userColumns
    };

    this.saveColumnsService.saveColumnOrderLandingPage(payload).subscribe({
      next: (response) => {
        console.log('Column order saved successfully:', response);
      },
      error: (error) => {
        console.error('Error saving column order:', error);
        this.notification = {
          label: 'Error',
          description: 'Failed to save column preferences',
          type: 'error'
        };
      }
    });
  }

  private loadSavedColumnOrder(): void {
    this.saveColumnsService.getColumnOrderLandingPage().subscribe({
      next: (response) => {
        console.log('Received column order from API:', response);
        if (response && response.userColumns && response.userColumns.length > 0) {
          this.applySavedColumnOrder(response.userColumns);
          console.log('Applied saved column order successfully');
        } else {
          console.log('No saved column order found, using default');
        }
      },
      error: (error) => {
        console.error('Error loading saved column order:', error);
      }
    });
  }

  private applySavedColumnOrder(savedColumns: UserColumn[]): void {
    try {
      const sortedSavedColumns = savedColumns.sort((a, b) => a.order - b.order);
      
      const orderedColumns: any[] = [];
      
      sortedSavedColumns.forEach(savedCol => {
        const existingColumn = this.tableHeaders.find(col => col.colName === savedCol.name);
        if (existingColumn) {
          orderedColumns.push({
            ...existingColumn,
            visible: savedCol.visible
          });
        }
      });
      
      this.tableHeaders.forEach(col => {
        if (!orderedColumns.find(orderedCol => orderedCol.colName === col.colName)) {
          orderedColumns.push(col);
        }
      });
      
      this.tableHeaders = orderedColumns;
      
    } catch (error) {
      console.error('Error applying saved column order:', error);
    }
  }

  setConfigureActive(tab: string): void {
    this.activeFilterTab = tab;
  }

  get isUserAdmin(): boolean {
    return this.dataService.profile.accessRole?.includes(USER_TYPE.SUPPORT_USER);
  }

  onNotificationChange(notification: Notification): void {
    this.notification = {} as Notification;
    setTimeout(() => { 
      this.notification = {...notification};
    },200);
  }

  onSetDefaultQuery(query: GetFilterQueryResponse, event: any): void {
    if (this.defaultQueryGuid === query.guid || query.isDefault === true) return;
    event.target.active = false;
    this.pendingDefaultQuery = query;
    this.showSetDefaultModal = true;
  }

  closeSetDefaultModal(): void {
    this.showSetDefaultModal = false;
    this.pendingDefaultQuery = null;
  }

  confirmSetDefault(): void {
    if (!this.pendingDefaultQuery) return;
    this.isSaving = true;

    this.filterCriteriaService.setDefaultFilter(this.pendingDefaultQuery.guid).subscribe({
      next: () => {
        for (const query of this.queries) {
          query.isDefault = false;
        }
        this.pendingDefaultQuery.isDefault = true;
        this.defaultQueryGuid = this.pendingDefaultQuery.guid;

        this.isSaving = false;
        this.showSetDefaultModal = false;
        this.pendingDefaultQuery = null;
        this.notification = {
          label: 'Success',
          description: 'Default template set successfully.',
          type: 'success'
        };
      },
      error: () => {
        this.isSaving = false;
        this.showSetDefaultModal = false;
        this.pendingDefaultQuery = null;
        this.notification = {
          label: 'Error',
          description: 'Failed to set default template.',
          type: 'error'
        };
      }
    });
  }

    get isUserOnlyAdmin(): boolean {
    return this.dataService.profile.accessRole.length == 1 && this.dataService.profile.accessRole?.includes(USER_TYPE.SUPPORT_USER);
  }

   onRouteChange(route: string): void {
    this.route.navigate([route]);
  }

onSearchOthers(): void {
    const term = this.searchValue?.trim();
    if (!term) return;

    this.isOthersSearchLoading = true;
    this.isShowingOthersResults = false;

    this.landingPageService.searchFilters(term, this.isManageTemplatePage).subscribe({
      next: (results) => {
        this.isOthersSearchLoading = false;
        if (results && results.length > 0) {
          this.queries = results.map(query => ({
            ...query,
            createdOnFormatted: query.createdOn?.split('T')[0],
            updatedOnFormatted: query.updatedon?.split('T')[0],
          }));
        } else {
          this.queries = [];
        }
        this.isShowingOthersResults = true;
        this.pageIndex = 1;
        this.updatePaginatedQueries();
      },
      error: () => {
        this.isOthersSearchLoading = false;
        this.isShowingOthersResults = true;
        this.queries = [];
        this.notification = {
          label: 'Error',
          description: this.isManageTemplatePage
            ? 'Failed to search templates.'
            : 'Failed to search queries.',
          type: 'error'
        };
      }
    });
  }


  resetToMyQueries(): void {
    this.isShowingOthersResults = false;
    this.queries = [...this.allQueriesFiltered];
    this.searchValue = '';
    this.pageIndex = 1;                  
    this.updatePaginatedQueries();       
  }

  getTotalPages(): number {
    if (this.showAll) return 1;
    return Math.ceil(this.getProcessedQueries().length / this.pageSize);
  }

  updatePaginatedQueries(): void {
    this.processedQueries = this.getProcessedQueries();
    if (this.showAll) {
      this.paginatedQueries = [...this.processedQueries];
      return;
    }
    const totalPages = this.getTotalPages();
    if (this.pageIndex > totalPages && totalPages > 0) {
      this.pageIndex = totalPages;
    }
    const start = (this.pageIndex - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedQueries = this.processedQueries.slice(start, end);
  }

  private getProcessedQueries(): GetFilterQueryResponse[] {
    let data = [...this.queries];

    // Apply per-column dropdown filters (e.g. Template type: Personal / Public)
    Object.keys(this.columnFilters).forEach(colName => {
      const rawFilterValue = this.columnFilters[colName] as any;
      if (rawFilterValue === null || rawFilterValue === undefined) return;

      // Some dropdown interactions emit 'All' as a literal label instead of an empty value.
      // Treat all of those representations as "no filter".
      if (Array.isArray(rawFilterValue)) {
        if (
          rawFilterValue.length === 0 ||
          rawFilterValue.some(v => String(v ?? '').trim().toLowerCase() === 'all')
        ) {
          return;
        }
      }

      const target = String(rawFilterValue).trim().toLowerCase();
      if (!target || target === 'all') return;

      data = data.filter(q =>
        String(this.getSortValue(q, colName) ?? '').trim().toLowerCase() === target
      );
    });

    // Apply column sorting
    if (this.sortField) {
      const field = this.sortField;
      const order = this.sortOrder;
      data = [...data].sort((a, b) => {
        const valA = this.getSortValue(a, field);
        const valB = this.getSortValue(b, field);
        if (valA == null && valB == null) return 0;
        if (valA == null) return order;
        if (valB == null) return -order;
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order;
        }
        const strA = String(valA).toLowerCase();
        const strB = String(valB).toLowerCase();
        if (strA < strB) return -1 * order;
        if (strA > strB) return 1 * order;
        return 0;
      });
    }
    return data;
  }

  private getSortValue(query: any, colName: string): any {
    switch (colName) {
      case 'createdBy': return query.email;
      case 'type': return this.getTypeLabel(query.type);
      case 'isDefault': return query.isDefault ? 1 : 0;
      default: return query[colName];
    }
  }

  onSort(event: any): void {
    this.sortField = event.field;
    this.sortOrder = event.order;
    this.pageIndex = 1;
    this.updatePaginatedQueries();
  }

  onColumnFilterChange(): void {
    this.pageIndex = 1;
    this.updatePaginatedQueries();
  }

  getColumnFilterOptions(colName: string): string[] {
    const values = this.queries
      .map(q => String(this.getSortValue(q, colName) ?? '').trim())
      .filter(v => v !== '');
    return Array.from(new Set(values)).sort((a, b) => a.localeCompare(b));
  }


  loadPreviousPage(event: any): void {
    if (this.pageIndex > 1) {
      this.pageIndex--;
      this.updatePaginatedQueries();
    }
  }

  loadNextPage(event: any): void {
    if (this.pageIndex < this.getTotalPages()) {
      this.pageIndex++;
      this.updatePaginatedQueries();
    }
  }

  loadSelectedPage(event: any): void {
   this.pageIndex = event.target.currentPage;
    this.updatePaginatedQueries();
  }

  pagePerRow(event: any): void {
    const value = event?.detail ?? event?.target?.value ?? event;
    if (value === 'All' || value === 'all') {
      this.showAll = true;
      this.pageIndex = 1;
    } else {
      this.showAll = false;
      this.pageSize = Number(value);
      this.pageIndex = 1;
    }
    this.updatePaginatedQueries();
  }

  
  private sortQueriesByFavoriteAndName(queries: GetFilterQueryResponse[]): GetFilterQueryResponse[] {
    return sortQueriesByFavoriteAndNameUtil(queries);
  }

  onToggleFavorite(isFavourite: boolean, selectedQuery: GetFilterQueryResponse ): void {
    const updatedQuery = { ...selectedQuery, isFavourite };
    this.filterCriteriaService.setFavorite(updatedQuery.guid, updatedQuery.isFavourite).subscribe({
      next: () => {
        this.queries = this.sortQueriesByFavoriteAndName(
          this.queries.map(query => query.guid === updatedQuery.guid ? updatedQuery : query)
        );
        this.allQueriesFiltered = this.sortQueriesByFavoriteAndName(
          this.allQueriesFiltered.map(query => query.guid === updatedQuery.guid ? updatedQuery : query)
        );
        this.updatePaginatedQueries();
        const message = isFavourite ? 'Marked as favorite' : 'Removed from favorites';
        this.notification = {
          label: 'Success',
          description: message,
          type: 'success'
        };
      }
    });
  }
}